module.exports = __webpack_public_path__ + "media/overlays/08-975f7e00.png";